import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
import clsx from 'clsx';
const TabListWrapperWithoutRef = ({ children, className, allowHorizontalScroll, ...commonProps }) => {
    const tabsWrapperClasses = clsx(styles.tabsWrapper, allowHorizontalScroll && styles.withScroll);
    return Depot.createElement('div', {
        ...commonProps,
        role: 'tablist',
        className: clsx(className, tabsWrapperClasses),
    }, children);
};
const TabListWrapper = Depot.withRef(TabListWrapperWithoutRef);
TabListWrapper.displayName = 'TabListWrapper';
export default TabListWrapper;
//# sourceMappingURL=index.js.map